/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S17_P1Inputs */

const tr_mesafeli_s17_p1 = /** @type {(inputs: Mesafeli_S17_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel ürünü, yazılımı, tasarımı ve tüm içeriği 5846 sayılı Fikir ve Sanat Eserleri Kanunu ile 6769 sayılı Sınai Mülkiyet Kanunu kapsamında korunmaktadır. ShopPanel markası Emonse E-Ticaret Limited Şirketi tarafından işletilmektedir. Müşteri, Abonelik süresi ile sınırlı, devredilemez ve münhasır olmayan bir kullanım lisansına sahiptir.`)
};

const en_mesafeli_s17_p1 = /** @type {(inputs: Mesafeli_S17_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The ShopPanel product, its software, design and all content are protected under Law No. 5846 on Intellectual and Artistic Works and Law No. 6769 on Industrial Property. The ShopPanel brand is operated by Emonse E-Ticaret Limited Şirketi. The Customer holds a non-transferable, non-exclusive licence of use limited to the Subscription term.`)
};

const de_mesafeli_s17_p1 = /** @type {(inputs: Mesafeli_S17_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Produkt ShopPanel, seine Software, sein Design und alle Inhalte sind nach dem Gesetz Nr. 5846 über Werke des Geistes und der Kunst sowie dem Gesetz Nr. 6769 über gewerbliches Eigentum geschützt. Die Marke ShopPanel wird von der Emonse E-Ticaret Limited Şirketi betrieben. Der Kunde erhält eine auf die Abonnementdauer beschränkte, nicht übertragbare und nicht ausschließliche Nutzungslizenz.`)
};

const ru_mesafeli_s17_p1 = /** @type {(inputs: Mesafeli_S17_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продукт ShopPanel, его программное обеспечение, дизайн и всё содержимое охраняются Законом № 5846 об интеллектуальных и художественных произведениях и Законом № 6769 о промышленной собственности. Бренд ShopPanel управляется компанией Emonse E-Ticaret Limited Şirketi. Клиент получает непередаваемую и неисключительную лицензию на использование, ограниченную сроком Подписки.`)
};

/**
* | output |
* | --- |
* | "The ShopPanel product, its software, design and all content are protected under Law No. 5846 on Intellectual and Artistic Works and Law No. 6769 on Industria..." |
*
* @param {Mesafeli_S17_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s17_p1 = /** @type {((inputs?: Mesafeli_S17_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S17_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s17_p1(inputs)
	if (locale === "de") return de_mesafeli_s17_p1(inputs)
	if (locale === "ru") return ru_mesafeli_s17_p1(inputs)
	return tr_mesafeli_s17_p1(inputs)
});